import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';
import { ToastrService } from 'ngx-toastr';
import { UserAuthService } from 'src/app/auth/user-auth.service';
import { IdleLogoutComponent } from 'src/app/shared/idle-logout/idle-logout.component';
import { HttpUtilService } from '../../services/http-util.service';
import { User } from './model/user.model'; 
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { CompanyService } from '../company/company.service';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  user: User;
  isLoggedIn = false;
  timer: any;
  showInactivityAlert = false;
  dialogRef: any;

  constructor(
    private httpUtilService: HttpUtilService,
    private httpClient: HttpClient,
    private toastr: ToastrService,
    private bnIdle: BnNgIdleService,
    private router: Router,
    public userAuthService: UserAuthService,
    public dialog: MatDialog,
    // private companyService: CompanyService
  ) {}

  // async login(params: any) :Promise<Observable<HttpResponse<Object>>> {
  //   const self = this;
  //   const apiEndpoint = 'users/login';
  //   return (await self.httpUtilService
  //     .login(params, apiEndpoint, null)).pipe(
  //       tap(async (response: HttpResponse<any>) => {
  //         if (response.body && response.body.user?.idCompany) {
  //           const companyId = response.body.user.idCompany;
  //           await this.companyService.getCompanyLogo(companyId).subscribe(); // ✅ Fetch logo immediately
  //         };
  //       }
  //     ))
  // }

  async login(params: any): Promise<Observable<HttpResponse<any>>> {
    const apiEndpoint = 'users/login';
    return this.httpUtilService.login(params, apiEndpoint, null);
  }

  loggedIn(): any {
    // // return true if token is not expired.
    // const email = localStorage.getItem('email');
    // // console.log(token);
    // if (email === null) {
    //   return false;
    // }
    // return true;
    const token = localStorage.getItem('token');
    if (token === null) {
      return false;
    }
    return true;
  }

  logout() {
    // Revoke all SSO refresh tokens on the server before clearing the local session.
    // This prevents external systems (e.g. Medkube) from silently refreshing
    // tokens for this user after logout.
    // Fire-and-forget: the interceptor adds the Bearer token synchronously
    // during subscribe(), before localStorage.clear() runs.
    this.httpClient.post(environment.apiUrl + 'sso/logout', {}).subscribe({ error: () => {} });

    if (this.timer) {
      this.bnIdle.resetTimer();
      this.bnIdle.stopTimer();
      this.timer.unsubscribe();
      this.timer = null;
      this.setInactivityAlert(false);
    }
    localStorage.clear();
  }

  async updateTwoFactorAuthentication(value:boolean):Promise<Observable<HttpResponse<Object>>> {
    return await this.httpUtilService
    .invokeQuery('POST', null, 'users/update2fa/' + value);
  }

  async validateSms(loginInfo:any, code:string):Promise<Observable<HttpResponse<Object>>> {
    const body = { ...loginInfo, Code: code };
    return await this.httpUtilService
    .invoke('POST', body, 'users/validatesms', null);
  }

  async sendSmsToNewPhone(newPhoneObject: any):Promise<Observable<HttpResponse<Object>>> {
    // invoke(method, postBody, endPoint, currentUserEmail) {
    return await this.httpUtilService
    .invoke('POST', newPhoneObject, 'users/send-sms-new-phone', null);
  }

  async sendSmsToNewPhoneAuthenticated(newPhoneObject: any):Promise<Observable<HttpResponse<Object>>> {
    // invoke(method, postBody, endPoint, currentUserEmail) {
    return await this.httpUtilService
    .invoke('POST', newPhoneObject, 'users/send-sms-new-phone-auth', null);
  }

  async confirmPhone(code: string):Promise<Observable<HttpResponse<Object>>> {
    // THIS IS FOR AN AUTHENTICATED PERSON
    return await this.httpUtilService
    .invoke('POST', { Code: code }, 'users/confirm-phone', null);
  }

  async resendSms(loginInfo: {username: string, password: string}):Promise<Observable<HttpResponse<Object>>> {
    return await this.httpUtilService
    .invoke('POST', loginInfo, 'users/resend-sms', null);
  }

  async resendSmsAuth():Promise<Observable<HttpResponse<Object>>> {
    return await this.httpUtilService
    .invoke('POST', null, 'users/resend-sms-auth', null);
  }

  setToken(user: any) {
    localStorage.setItem('access_token', user.token);
    localStorage.setItem('token_type', user.token_type);
    localStorage.setItem('expires_in', user.expires_in);
    localStorage.setItem('openDataUser', user.openData?"1":"0");
  }
 
  stopTimer() {
    this.bnIdle.stopTimer();
  }

  resetTimer() {
    this.bnIdle.resetTimer();
  }

  startTimer() {
    this.timer = this.bnIdle
      .startWatching(1200)
      //.startWatching(60)
      .subscribe((isTimedOut: boolean) => {
        // console.log(isTimedOut);
        if (isTimedOut) {
          this.bnIdle.stopTimer();
          this.bnIdle.resetTimer();
          this.showIdleTimer();
        }
      });
  }

  requestAffiliationToCompany(ruc: string):Promise<Observable<HttpResponse<Object>>> {
    const self = this;
    const apiEndpoint = 'company/affiliate/' + ruc;
    return self.httpUtilService.invokeQuery("POST", null, apiEndpoint)
  }

  setInactivityAlert(value: boolean): any {
    this.showInactivityAlert = value;
  }

  showIdleTimer() {
    if (this.dialogRef) {
      return;
    }

    this.dialogRef = this.dialog.open(IdleLogoutComponent, {
      panelClass: 'custom-dialog',
      data: {},
      autoFocus: false,
      maxWidth: '120vh',
    });
    this.dialogRef.afterClosed().subscribe((response: any) => {
      this.dialogRef = null;
      this.bnIdle.resetTimer();
      this.bnIdle.stopTimer();
      this.timer.unsubscribe();
      this.timer = null;
      if (response !== undefined && response.logout === false) {
        this.showInactivityAlert = false;
        this.startTimer();
      } else {
        this.showInactivityAlert = true;
        this.router.navigateByUrl('/login');
        // this.timer.unsubscribe();
        // this.logout();
      }
    });
  }

  async updateOpenData(id: number, status: number):Promise<Observable<HttpResponse<Object>>> {
    const apiEndpoint = 'users/updateopendata';
    const params = {
      key: 'status',
      value: status,
    };

    return this.httpUtilService
      .invokePathParam("POST", params, null, apiEndpoint);
  }

  // async validateSms(loginInfo:any, code:string):Promise<Observable<HttpResponse<Object>>> {
  //   // invoke(method, postBody, endPoint, currentUserEmail) {
  //   return await this.httpUtilService
  //   .invoke('POST', loginInfo, 'users/validatesms/' + code + '/', null);
  
  // }


  saveMedicSignature(signature: any):Promise<Observable<HttpResponse<Object>>> {
    const self = this;
    const apiEndpoint = 'users/medic/signature'; 

    // return self.httpUtilService.invokeWithFormData('POST', signature, apiEndpoint);
    return self.httpUtilService.invokePostWithFormData('POST', signature, apiEndpoint, '');

    // return this.httpUtilService.invokePostWithFormData(
    //   'POST',
    //   signature,
    //   'users/medic/signature',
    //   null
    // );
  }

  getMedicSignature() :Promise<Observable<HttpResponse<Object>>> {
    const self = this;
    const apiEndpoint = 'users/medic/signature'; 

    return self.httpUtilService.invoke('GET', null, apiEndpoint, '');
  }

  knowIfNeedChangePassword(email:string) {
    const apiEndpoint = 'users/knowifneedchangepassword';
    // const apiEndpoint = 'token';
    const params1 = {
      key: 'email',
      value: email,
    };
    return this.httpUtilService
      .invokeQuery("GET", params1, apiEndpoint)
      .then((response) => {
          return response;
        }
      )
      .catch((error) => {
        console.log(error);
        this.toastr.error(
          'Se ha producido un error, intentelo mas tarde'
        );
        return false;
      });
  }

  storeUserSession(user: any): void {
    localStorage.setItem('loggedInID', user.id.toString());
    localStorage.setItem('roleId', user.role.toString());

    // ✅ Store all role names as a JSON array
    if (user.roles) {
      localStorage.setItem('roles', JSON.stringify(user.roles));
    }

    // Store flags if needed for quick checks
    if (user.roles.includes('patient')) {
      localStorage.setItem('role', 'patient');
    } else if (user.roles.includes('labtech')) {
      localStorage.setItem('role', 'labtech');
    } else if (user.roles.includes('medic')) {
      localStorage.setItem('role', 'medic');
    } else {
      localStorage.setItem('role', 'admin');
    }

    if (user.idCompany) {
      localStorage.setItem('idCompanyUser', user.idCompany.toString());
    }
    if (user.idLocal) {
      localStorage.setItem('idLocalUser', user.idLocal.toString());
    }
    if (user.openData) {
      localStorage.setItem('openDataUser', "1");
    }
    if (user.token) {
      localStorage.setItem('token', user.token);
    }
  }


  // storeUserSession(user: any): void {
  //   localStorage.setItem('loggedInID', user.id.toString());
  //   localStorage.setItem('roleId', user.role.toString());
  
  //   if (user.role === 4) {
  //     localStorage.setItem('role', 'patient');
  //   } else if (user.role === 5) {
  //     localStorage.setItem('role', 'lab');
  //   } else if (user.role === 2) {
  //     localStorage.setItem('role', 'medic');
  //   } else {
  //     localStorage.setItem('role', 'admin');
  //   }
  
  //   if (user.idCompany) {
  //     localStorage.setItem('idCompanyUser', user.idCompany.toString());
  //   }
  //   if (user.idLocal) {
  //     localStorage.setItem('idLocalUser', user.idLocal.toString());
  //   }
  //   if (user.openData) {
  //     localStorage.setItem('openDataUser', "1");
  //   }
  //   if (user.token) {
  //     localStorage.setItem('token', user.token);
  //   }
  // }

}